import moment from 'moment';

const  formattedShiftTimeRange = (shift) => {
    const start = moment(shift.start_at).local().clone();
    const end = moment(shift.end_at).local().clone();
    const formatString = 'h:mma';
    const startString = start.format(formatString);
    const endString = end.format(formatString);

    const displayStartString = startString.substring(0, startString.length-1);
    const displayEndString = endString.substring(0, endString.length-1);

    const timeRange = `${displayStartString} - ${displayEndString}`;
    return timeRange;
}

const summaryDateRange = (rangeStart, rangeEnd) => {
  const start = rangeStart.local().clone();
  const end = rangeEnd.local().clone();
  const startString = start.format('MMM DD');
  const endString = end.format('MMM DD, YYYY');
  const result = startString + ' - ' + endString;
  return result;
}

const shiftTitleDate = (date) => {
  const formatString = 'ddd, MMM DD';
  const start = moment(date).local().clone();
  const result = start.format(formatString);
  return result;
}

const shiftDetailTitle = (shift) => {
  const date = shiftTitleDate(shift?.start_at)
  const range = formattedShiftTimeRange(shift)
  if( shift.primary_job == null || shift.primary_job == undefined || shift.primary_job == '' ){
    return `${date} • ${range}`
  }else{
    return `${date} • ${range} • ${shift.primary_job}`
  }
}

const durationString = (start, end) => {
  // console.log(start + ' ' + end);
  const startVal = moment(start).local().clone();
  const endVal = moment(end).local().clone();
  const diff = moment.duration(endVal.diff(startVal));
  const hours = parseFloat(diff.asHours()).toFixed(2);
  return hours;
}

const pickerHourTimeZoneFormat = (timestamp) => {
  return moment(timestamp).format(hourTimeZoneFormat())
}

const getNameFromUser = (user) => {
  if (!user) return '';

  let fullName = '';
  if (user.first_name && user.first_name.length > 0) {
    fullName += user.first_name;
  }
  if (user.last_name && user.last_name.length > 0) {
    fullName += ` ${user.last_name}`;
  }
  return fullName.trim();
}

const hourTimeZoneFormat = () => 'HH:mm:00Z';

export default {
    formattedShiftTimeRange,
    hourTimeZoneFormat,
    summaryDateRange,
    durationString,
    shiftDetailTitle,
    shiftTitleDate,
    pickerHourTimeZoneFormat,
    getNameFromUser,
};